import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingList: false,
  errorList: null,
  loadingUnsubscribe: false,
  errorUnsubscribe: null,
  data: {
    auth: { token: null, obfuscatedEmail: null },
    profile: { campaigns: [] },
    unsubscribe: { success: false }
  }
}

const ongageUnsubscribeSlice = createSlice({
  name: 'ongageUnsubscribe',
  initialState,
  reducers: {
    fetchOngageUnsubscribeRequest: state => {
      state.loadingList = true
      state.errorList = null
      state.data.profile.campaigns = []
    },
    fetchAuthTokenSuccess: (state, { payload }) => {
      state.data.auth.token = payload
    },
    fetchObfuscatedEmailSuccess: (state, { payload }) => {
      state.data.auth.obfuscatedEmail = payload
    },
    fetchListProfileSuccess: (state, { payload }) => {
      state.data.profile.campaigns = payload
      state.loadingList = false
    },
    fetchListProfileFailure: (state, { payload }) => {
      state.errorList = payload
      state.loadingList = false
    },
    postCampaignsBulkSubscriptionRequest: state => {
      state.loadingUnsubscribe = true
      state.errorUnsubscribe = null
      state.data.unsubscribe.success = false
    },
    postCampaignsBulkSubscriptionSuccess: state => {
      state.data.unsubscribe.success = true
      state.loadingUnsubscribe = false
    },
    postCampaignsBulkSubscriptionFailure: (state, { payload }) => {
      state.errorUnsubscribe = payload
      state.loadingUnsubscribe = false
    }
  }
})

export const {
  fetchOngageUnsubscribeRequest,
  fetchAuthTokenSuccess,
  fetchObfuscatedEmailSuccess,
  fetchListProfileSuccess,
  fetchListProfileFailure,
  postCampaignsBulkSubscriptionRequest,
  postCampaignsBulkSubscriptionSuccess,
  postCampaignsBulkSubscriptionFailure
} = ongageUnsubscribeSlice.actions

export default ongageUnsubscribeSlice.reducer
